module.exports = __webpack_public_path__ + "img/00037.821ae8e2.webp";